import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "k0d2dc91",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-02-01"
});